import React from "react";

// Shared Keys
export type ItemKey = string | number;

export type FieldAccessor<T, R> = {
  kind: "field";
  field: keyof T;
};

export type GetterAccessor<T, R> = {
  kind: "get";
  get: (item: T) => R;
};

export type Accessor<T, R> = FieldAccessor<T, R> | GetterAccessor<T, R>;

export function readWithAccessor<T, R>(item: T, accessor: Accessor<T, R>): R {
  if (accessor.kind === "get") {
    return accessor.get(item);
  }

  return item[accessor.field] as unknown as R;
}

// Display + grouping types
export type DisplayField<T> = {
  label: string;
  accessor: Accessor<T, unknown>;
  searchable?: boolean;
  render?: (value: unknown, item: T) => React.ReactNode;
  width?: number;
};

export type GroupBy<T> = {
  /** Group label prefix (e.g. "Season") */
  label: string;

  accessor: Accessor<T, unknown>;
};

export type NormalizedItem<T> = {
  key: ItemKey;
  fields: {
    value: any;
    searchable: boolean;
    render?: (value: any, item: T) => React.ReactNode;
  }[];
  raw: T;
  searchText: string;
  disabled: boolean;
};

export type GroupNode<T> =
  | {
      type: "item";
      item: NormalizedItem<T>;
      hasSelectableItems: boolean;
    }
  | {
      type: "group";
      id: string;
      label: string;
      children: GroupNode<T>[];
      hasSelectableItems: boolean;
    };
